import { Button } from '@/components/Button/Button';
import { t } from '@/lib/i18n';
import type { LlmKeyRow } from '../schemas';
import styles from './LlmKeyCard.module.css';

interface Props {
  keyRow: LlmKeyRow;
  onEdit: (id: string) => void;
  onTest: (id: string) => void;
  onMakeDefault: (id: string) => void;
  onDelete: (id: string) => void;
  busy?: boolean;
}

const PROVIDER_LABELS: Record<LlmKeyRow['provider'], string> = {
  anthropic: 'Anthropic',
  openai: 'OpenAI',
  google: 'Google',
};

export function LlmKeyCard({ keyRow, onEdit, onTest, onMakeDefault, onDelete, busy }: Props) {
  return (
    <article className={styles.card} aria-busy={busy ?? undefined}>
      <header className={styles.header}>
        <div className={styles['title-wrap']}>
          <h3 className={styles.label}>{keyRow.label}</h3>
          {keyRow.isDefault && <span className={styles.badge}>DEFAULT</span>}
        </div>
        <span className={styles.provider}>{PROVIDER_LABELS[keyRow.provider]}</span>
      </header>
      <p className={styles.meta}>
        <span>{keyRow.model}</span>
        <span aria-hidden> · </span>
        <span className={styles.fingerprint}>…{keyRow.fingerprint}</span>
      </p>
      <div className={styles.actions}>
        <Button variant="secondary" size="sm" onClick={() => onTest(keyRow.id)} disabled={busy}>
          {t('Test')}
        </Button>
        <Button variant="secondary" size="sm" onClick={() => onEdit(keyRow.id)} disabled={busy}>
          {t('Edit')}
        </Button>
        {!keyRow.isDefault && (
          <Button
            variant="secondary"
            size="sm"
            onClick={() => onMakeDefault(keyRow.id)}
            disabled={busy}
          >
            {t('Make default')}
          </Button>
        )}
        <Button variant="danger" size="sm" onClick={() => onDelete(keyRow.id)} disabled={busy}>
          {t('Delete')}
        </Button>
      </div>
    </article>
  );
}
